import { IonList } from "@ionic/react";
import { compact, sortBy } from "es-toolkit";
import {
  memo,
  useRef,
  useState,
} from "react";
import { Virtualizer, VListHandle } from "virtua";

import { cx } from "#/helpers/css";
import { isSafariFeedHackEnabled } from "#/routes/pages/shared/FeedContent";

import FeedProfile from "#/routes/pages/curators/FeedProfile"
import { PersonView } from "#/features/user/userTypes";

import styles from "./CuratorsList.module.css";

const OVERSCAN_AMOUNT = 3;

interface CuratorsListParams {
  curators: PersonView[];
  onListAtTopChange?: (isAtTop: boolean) => void;
}

function CuratorsList({
  curators,
  onListAtTopChange,
}: CuratorsListParams) {
  const virtuaRef = useRef<VListHandle>(null);
  const [shift, setShift] = useState(false);

  return (
    <div
    className={cx(
        styles.virtualizerScrollView,
        isSafariFeedHackEnabled
        ? "virtual-scroller"
        : "ion-content-scroll-host virtual-scroller",
    )}
    >
    <Virtualizer
      shift={shift}
      ref={virtuaRef}
      overscan={OVERSCAN_AMOUNT}
      onScroll={(offset) => {
        onListAtTopChange?.(offset < 10);

      // if (virtuaRef.current) {
      //     setShift(
      //     virtuaRef.current.findStartIndex() >
      //         throughFavoritesCount + OVERSCAN_AMOUNT, // overscan
      //     );
      // } else {
          setShift(false);
      // }

      // updateActiveIndex();
      }}
      // @ts-expect-error Virtua types not correct
      as={IonList}
      // keepMounted={activeIndex >= 0 ? [activeIndex] : []}
      // item={StickyItem}
    >
      {curators.map((curator, index) => (
        <FeedProfile
          person={curator}
          key={index}
        />
      ))}
    </Virtualizer>
    </div>
  );
}

export default memo(CuratorsList);
